import {GeotabLcService} from './geotab-lc.service';
import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Router, RouterOutlet} from '@angular/router';

declare var geotab: any;

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  standalone: true,
  styleUrl: './app.component.scss',
  encapsulation: ViewEncapsulation.ShadowDom
})

export class AppComponent implements OnInit{
  title = 'rc_geotab_addon';
  constructor(private readonly translate: TranslateService,
              public router: Router, public geotabLcService: GeotabLcService) {
    this.translate.addLangs(['en']);
    this.translate.setFallbackLang('en');
    this.translate.use('en');
  }

  /* istanbul ignore next */
  ngOnInit(): void {
    // This value is set in the localstorage by GeoTab
    if(localStorage.getItem('logout_database')){
      this.removeSessionStorage(localStorage.getItem('logout_database'));
    }
    if(!localStorage.getItem('isEulaAccepted')) {
      localStorage.setItem('isEulaAccepted', 'false');
    }
    geotab.addin.rc = () => {
      return {
        initialize: (api: any, state: any, callback: () => void) =>{
          console.log('Add-in is initialized.');
          this.fetchSessionIdAndUpdateLifecycle(api, 'initialized', 5);
          callback();
        },
        focus: (api: any, state: any) => {
          console.log('Add-in is focused');
          this.fetchSessionIdAndUpdateLifecycle(api, 'focused', 2)
        },
        blur: (api: any, state: any) => {
          api.getSession((session: any) => {
            console.log('Add-in is blurred');
            this.removeSessionStorage(session.database);
            this.geotabLcService.updateLifecycle('blured');
          });
        }
      }
    }
  }

  fetchSessionIdAndUpdateLifecycle(api: any, targetLifecycle, maxRetries): void {
    api.getSession((session: any) => {
      if (maxRetries <= 0) {
        console.log(`sessionId not retrieved within callback of ${targetLifecycle}, max retries reached`);
        this.geotabLcService.updateLifecycle(targetLifecycle);
        return;
      }
      // we'll update the lifecycle only after retrieving the session id
      if (!session.sessionId) {
        // retry
        console.log(`sessionId not retrieved within callback of ${targetLifecycle}, retrying with remaing ${maxRetries - 1}...`);
        // wait a bit
        setTimeout(() => {
          this.fetchSessionIdAndUpdateLifecycle(api, targetLifecycle, maxRetries - 1);
        }, 200);
      } else {
        console.log('sessionId retrieved on ' + targetLifecycle);
        sessionStorage.setItem(`ridecare_${session.database}`, JSON.stringify(session));
        sessionStorage.setItem('database', session.database);
        this.geotabLcService.updateLifecycle(targetLifecycle);
      }
    })
  }

  /* istanbul ignore next */
  removeSessionStorage(database: string): void {
    sessionStorage.removeItem(`ridecare_${database}`);
    sessionStorage.removeItem(`authToken_${database}`);
    sessionStorage.removeItem(`refreshToken_${database}`);
    sessionStorage.removeItem(`tenant_${database}`);
  }
}
